import React from "react";
import { Link } from "react-router-dom";

const ExperienceTransformationLayout = () => {
    return (
        <div className="bg-white text-gray-900">

            {/* ================= HERO ================= */}
            <section
                className="relative min-h-[85vh] flex items-center"
                style={{
                    backgroundImage:
                        "url(/images/services/heroexprience.png)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="absolute inset-0 bg-slate-900/75" />
                <div className="relative max-w-7xl mx-auto px-6 py-24 text-white">
                    <span className="uppercase text-sm text-orange-400 tracking-wide">
                        Services
                    </span>
                    <h1 className="text-5xl md:text-6xl font-bold mt-4 mb-6">
                        Re-imagining Experiences That Drive Growth
                    </h1>
                    <p className="text-xl max-w-3xl text-gray-200 mb-8">
                        Transform customer, employee, and digital experiences using
                        human-centered design, AI, and data-driven insights.
                    </p>
                    <Link
                        to="/contact"
                        className="inline-block bg-orange-500 hover:bg-orange-600 px-8 py-4 rounded-lg font-semibold"
                    >
                        Read the Story
                    </Link>
                </div>
            </section>

            {/* ================= INTRO VIDEO ================= */}
            <section className="max-w-7xl mx-auto px-6 py-20">
                <p className="text-gray-600 max-w-4xl mb-10">
                    Today’s customer journeys are complex and fragmented. Experience
                    Transformation enables organizations to deliver seamless,
                    personalized, and outcome-driven engagements at scale.
                </p>

                <div className="rounded-2xl overflow-hidden shadow-xl">
                    <iframe
                        className="w-full h-[320px] md:h-[480px]"
                        src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                        title="Experience Transformation"
                        allowFullScreen
                    />
                </div>
            </section>

            {/* ================= VALUE TO CLIENTS ================= */}
            <section className="bg-gray-50">
                <div className="max-w-7xl mx-auto px-6 py-20">
                    <h2 className="text-3xl font-bold mb-10">Value to Clients</h2>
                    <div className="grid md:grid-cols-4 gap-8">
                        {[
                            { title: "Approach", text: "Human-centric, insight-driven experience strategy." },
                            { title: "Ethics", text: "Responsible AI and inclusive design principles." },
                            { title: "Personalization", text: "Context-aware, data-powered interactions." },
                            { title: "Impact", text: "Measurable business outcomes and CX uplift." },
                        ].map((item) => (
                            <div key={item.title} className="bg-white p-6 rounded-xl shadow">
                                <h4 className="font-semibold mb-2">{item.title}</h4>
                                <p className="text-sm text-gray-600">{item.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= ELEVATED OFFERINGS ================= */}
            <section className="max-w-7xl mx-auto px-6 py-20">
                <h2 className="text-3xl font-bold mb-10">Elevated Offerings</h2>
                <div className="grid md:grid-cols-4 gap-8">
                    {[
                        "Experience Strategy",
                        "Design Thinking",
                        "Digital Platforms",
                        "Growth Optimization",
                    ].map((item) => (
                        <div key={item} className="bg-gray-50 p-6 rounded-xl shadow">
                            <h4 className="font-semibold mb-3">{item}</h4>
                            <p className="text-sm text-gray-600">
                                Deliver engaging, scalable experiences aligned to business
                                goals and user needs.
                            </p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ================= APEX SECTION ================= */}
            <section className="bg-indigo-900 text-white">
                <div className="max-w-7xl mx-auto px-6 py-20">
                    <h2 className="text-3xl font-bold mb-6">
                        APEX: Where AI Meets Purpose and Trust
                    </h2>
                    <p className="text-indigo-200 max-w-4xl mb-10">
                        APEX combines strategy, design, data, and AI to create trusted,
                        intelligent experiences across every digital touchpoint.
                    </p>
                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            "Augment – Shift Perspective",
                            "Amplify – Drive Innovation",
                            "Accelerate – Deliver Faster",
                        ].map((item) => (
                            <div key={item} className="bg-white/10 p-6 rounded-xl">
                                <h4 className="font-semibold mb-2">{item}</h4>
                                <p className="text-sm text-indigo-100">
                                    Drive continuous improvement through AI-powered experience
                                    design.
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= XT STUDIO ================= */}
            {/* <section className="max-w-7xl mx-auto px-6 py-20 text-center">
                <h2 className="text-3xl font-bold mb-6">XT Studio</h2>
                <p className="text-gray-600 max-w-3xl mx-auto mb-10">
                    XT Studio is where vision meets execution—co-creating immersive,
                    scalable experiences with design, engineering, and AI.
                </p>
                <Link
                    to="/contact"
                    className="inline-block bg-orange-500 px-8 py-4 rounded-lg font-semibold text-white"
                >
                    Know More
                </Link>
            </section> */}

            {/* ================= CLIENT SUCCESS ================= */}
            <section className="bg-gray-50">
                <div className="max-w-7xl mx-auto px-6 py-20">
                    <h2 className="text-3xl font-bold mb-10">Client Success</h2>

                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            {
                                title: "Healthcare Experience Modernization",
                                image:
                                    "/images/experiencetransformation/cs1.png",
                            },
                            {
                                title: "Automotive Digital Transformation",
                                image:
                                    "/images/experiencetransformation/cs2.png",
                            },
                            {
                                title: "Enterprise CX Platform Revamp",
                                image:
                                    "/images/experiencetransformation/cs3.png",
                            },
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="bg-white rounded-xl shadow overflow-hidden"
                            >
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    className="h-48 w-full object-cover"
                                />

                                <div className="p-6">
                                    <h4 className="font-semibold mb-3">{item.title}</h4>
                                    <Link
                                        to="/client-success"
                                        className="text-orange-500 font-medium"
                                    >
                                        Read the Story →
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* ================= WHY US ================= */}
            <section className="bg-indigo-900 text-white">
                <div className="max-w-7xl mx-auto px-6 py-20">
                    <h2 className="text-3xl font-bold mb-10">Why TECHSPR?</h2>
                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            "End-to-End Execution",
                            "Accelerated Time-to-Value",
                            "APEX Experience Framework",
                        ].map((item) => (
                            <div key={item} className="bg-white/10 p-6 rounded-xl">
                                <p className="font-semibold">{item}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= CONTACT ================= */}
            <section className="bg-gray-100">
                <div className="max-w-7xl mx-auto px-6 py-20 text-center">
                    <h2 className="text-4xl font-bold mb-6">
                        Let’s Transform Experiences Together
                    </h2>
                    <p className="text-gray-600 mb-8">
                        Partner with TECHSPR to design and deliver experiences that
                        accelerate growth.
                    </p>
                    <Link
                        to="/contact"
                        className="inline-block bg-orange-500 px-10 py-4 rounded-lg font-semibold text-white"
                    >
                        Contact Us
                    </Link>
                </div>
            </section>

        </div>
    );
};

export default ExperienceTransformationLayout;
